import { useState, useCallback, useRef } from "react";

export const ZOOM_STEP = 1.25;
export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 10;

export function useZoom() {
  const [zoom, setZoom] = useState(1);
  const zoomRef = useRef(zoom);
  zoomRef.current = zoom;

  const scrollToKksRef = useRef<number | null>(null);
  const pendingPageRenderRef = useRef(false);
  const selectedIdxRef = useRef<number | null>(null);

  const zoomAndRecenter = useCallback((newZoom: number) => {
    scrollToKksRef.current = selectedIdxRef.current;
    pendingPageRenderRef.current = newZoom !== zoomRef.current;
    setZoom(newZoom);
  }, []);

  const zoomIn = useCallback(
    () => zoomAndRecenter(Math.min(MAX_ZOOM, zoom * ZOOM_STEP)),
    [zoom, zoomAndRecenter],
  );
  const zoomOut = useCallback(
    () => zoomAndRecenter(Math.max(MIN_ZOOM, zoom / ZOOM_STEP)),
    [zoom, zoomAndRecenter],
  );
  const zoomReset = useCallback(() => zoomAndRecenter(1), [zoomAndRecenter]);

  return {
    zoom,
    setZoom,
    zoomRef,
    zoomIn,
    zoomOut,
    zoomReset,
    zoomAndRecenter,
    scrollToKksRef,
    pendingPageRenderRef,
    selectedIdxRef,
  };
}
